import './Folder.sass'
import {useState} from 'react'
import {Row, Col, Card} from 'react-bootstrap'
import ReqRes, {isReqRes} from './ReqRes.js'

import {ReactComponent as IconFolder} from 'img/icon/folder.svg'
import {merge} from 'lodash'

import IconExpandContract from './IconExpandContract.js'
import Markdown from 'comps/Markdown.js'

const Folder = (props) => {
    const isFolder = (props) => {
        return Array.isArray(props.item) && props.item.length > 0
    }  

    const [showContent, _setshowContent] = useState(false)
    const toggleFolderContent = () => _setshowContent(!showContent)
  
    if(isReqRes(props)){
      return <ReqRes {...props} inFolder className={props.inFolder ? 'folder-child' : ''}/>
    }
    
    if(isFolder(props) && props.recursion){
      return (
        <>
          <Card className="folder-container" style={merge({marginTop: 20, marginBottom: 10}, props.style)}>
            <Card.Header as="h4" onClick={toggleFolderContent} className="cursor-pointer folder-title">
              <Row>
                <Col xs="auto" className="d-flex align-items-center">
                  <IconFolder width="25px" height="25px" />
                </Col>
                <Col className="d-flex align-items-center pl-0">{props.name}</Col>
                <Col xs="auto" className="d-flex align-items-center">
                  <IconExpandContract value={!showContent} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>{props.description ? <Markdown small style={{fontSize: '70%', fontWeight: 300}}>{props.description}</Markdown> : null}</Col>
              </Row>
            </Card.Header>
            <Card.Body className={`content-expandable ${showContent?'show':'hide'}`}>
              {props.item.map((o, i)=><Folder inFolder key={i} {...o}/>)}
            </Card.Body>
          </Card>
        </>
      )
    }

    return null
}
Folder.defaultProps = {
  recursion: true // Render folder inside folder if true.
}

export default Folder
